// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';
export var PauseFilled = createSvgIcon({ LeftToRight: React.createElement(React.Fragment, null,
        React.createElement("g", { fill: "currentColor", stroke: "transparent" },
            React.createElement("rect", { width: "10.0359", height: "23.9771", x: "-.0047", rx: "1" }),
            React.createElement("rect", { width: "10.0359", height: "23.9771", x: "13.9641", rx: "1" })),
        React.createElement("defs", null)), }, 'medium');
//# sourceMappingURL=PauseFilled.js.map